/**
 * `/shop/<slug>/table/<eventId>/<itemId>` — one card at a table (TRO-1187).
 *
 * A scanned label still narrows the shop's list with `?item=` (`shopItemPath`, ADR-0056); a card
 * tapped on the shop opens its own page, `/shop/<slug>/item/<id>`, without the table's pick list.
 */
export { default } from "../../../../browse/[eventId]/[itemId]";
